import { TicketTypeRow } from './TicketTypeRow'
import { generateUuid } from '../../../utils/uuids'
import { generateCode } from '../../../utils/code'
import { dateTimeV2Service } from '../../../domain/value-object/DateTimeV2'

// デフォルトアイコン: 成果物アイコン
const DEFAULT_DELIVERABLE_ICON =
  'https://flagxs.sevend.net/cdn/global/icons/deliverable.svg'

/**
 * 新しいチケットタイプ行を作成
 * @param existingCodes 既存のコード一覧（重複チェック用）
 * @param displayOrder 表示順序（省略時は999）
 */
export const createNewTicketTypeRow = (
  existingCodes: string[] = [],
  displayOrder: number = 999
): TicketTypeRow => {
  const uuid = generateUuid()
  const code = generateCode(existingCodes)

  return {
    uuid,
    name: '',
    code,
    iconUrl: DEFAULT_DELIVERABLE_ICON,
    isUsed: false, // デフォルトは使用中ではない
    isPreset: false, // 新しく作成する行はプリセットではない
    displayOrder, // ドラッグ&ドロップ用の表示順序
    createdAt: dateTimeV2Service.now(),
    updatedAt: dateTimeV2Service.now(),
    isAdded: true, // 新規追加行であることを示すフラグ
  }
}
